import React from 'react';

const FeaturedImageSlot = ({
  slotNumber,
  currentImageId,
  isUploading,
  contactFiles,
  onImageUpload,
  onImageSelect,
  onImageRemove,
  getImageUrl,
}) => {
  const imageUrl = getImageUrl(currentImageId);

  return (
    <div
      className="featured-image-slot"
    >
      <h4>Featured Image {slotNumber}</h4>

      {currentImageId && imageUrl && (
        <div style={{ marginBottom: '10px' }}>
          <div className="flex-center">
            <img
              src={imageUrl}
              alt={`Featured ${slotNumber}`}
              style={{
                width: '400px',
                objectFit: 'cover',
              }}
              onError={e => {
                console.error(`Failed to load image: ${imageUrl}`);
                e.target.style.display = 'none';
              }}
            />
          </div>
          <br />
          <div className="flex-center">
            <button
              type="button"
              className="button"
              onClick={() => onImageRemove(slotNumber)}
            >
              <div className="align-icon">
                <i className="fa-times-circle-o"></i>
              </div>
              Remove
            </button>
          </div>
        </div>
      )}

      <div style={{ marginBottom: '10px' }}>
        <input
          type="file"
          accept="image/*"
          onChange={e => {
            const file = e.target.files[0];
            if (file) onImageUpload(file, slotNumber);
          }}
          disabled={isUploading}
          style={{ marginBottom: '5px' }}
        />
        {isUploading && (
          <div style={{ fontSize: '12px', color: '#666' }}>Uploading...</div>
        )}
      </div>

      {contactFiles.length > 0 && (
        <div>
          <label style={{ fontSize: '12px', fontWeight: 'bold' }}>
            Or select existing image:
          </label>
          <select
            value={currentImageId || ''}
            onChange={e =>
              onImageSelect(
                e.target.value ? parseInt(e.target.value) : null,
                slotNumber,
              )
            }
            style={{ width: '100%', marginTop: '5px' }}
          >
            <option value="">Select an image...</option>
            {contactFiles.map(file => (
              <option key={file.id} value={file.id}>
                {file.filename || `Image ${file.id}`}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default FeaturedImageSlot;
